import React, { Component } from 'react';
import {
    Container,
    Typography,
    Box,
    Paper,
    withStyles
} from '@material-ui/core';
import PrintIcon from '@material-ui/icons/Print';
import HomeIcon from '@material-ui/icons/Home';
import BreadcrumbLayout from "../../shared/components/common/breadcrumbLayout";
import CustomButton from "../../shared/components/common/customButton";

const styles = (theme) => ({
    container: {
        backgroundColor: '#FFFFFF',
        minHeight: '100vh',
        padding: '1.875rem',
    },
    printArea: {
        maxWidth: 800,
        margin: '0 auto',
        backgroundColor: '#FFFFFF',
        padding: "1.25rem 1.875rem",
        border: '1px solid #CCCCCC',
        borderRadius: '0.5rem',
        boxShadow: 'none',
        [theme.breakpoints.down('sm')]: {
            padding: "1.25rem 1.875rem",
        },
    },
    title: {
        color: '#2C3E50',
        borderBottom: '1px solid #CCCCCC',
        paddingBottom: '0.3125rem',
        marginBottom: '0.625rem',
        fontSize: 'calc(1.3rem + .6vw)',
    },
    bodyText: {
        color: '#333333',
        fontSize: '1rem',
        lineHeight: '1.5',
        marginBottom: '1rem',
    },
    inlineBlockText: {
        display: 'inline-block',
        width: '7.5rem',
    },
    highlightText: {
        fontSize: '1.3em',
        fontWeight: 'bold',
        backgroundColor: '#EEEEFF',
        padding: '0.5rem',
        borderRadius: '0.25rem',
        marginBottom: '0.9375rem',
    },
    section: {
        marginBottom: '1.25rem',
    },
    subTitle: {
        borderBottom: '1px solid #CCCCCC',
        paddingBottom: '0.3125rem',
        marginBottom: '0.625rem',
        color: '#333333',
        fontSize: '1.25rem',
    },
    observationSection: {
        fontSize: '0.95rem',
        color: '#333333',
        backgroundColor: '#FFF3CD',
        padding: '0.625rem',
        borderLeft: '0.3125rem solid #FFC107',
        borderRadius: '0.3125rem',
        marginTop: '1.25rem',
    },
    warningSection: {
        backgroundColor: '#F8D7DA',
        padding: '0.625rem',
        borderLeft: '0.3125rem solid #DC3545',
        borderRadius: '0.3125rem',
        marginTop: '0.625rem',
    },
    warningTitle: {
        color: '#333333',
        fontSize: '1.25rem',
        borderBottom: '1px solid #CCCCCC',
        paddingBottom: '0.3125rem',
        marginBottom: '0.625rem',
    },
    warningText: {
        fontSize: '0.95em',
        color: '#333333',
    },
    signatureSection: {
        borderTop: '1px solid #CCCCCC',
        paddingTop: '0.625rem',
        marginTop: '1.875rem',
    },
    signatureText: {
        fontSize: '0.9em',
        color: '#555555',
        marginBottom: '1rem',
    },
    buttonGroup: {
        display: 'flex',
        gap: theme.spacing(2),
        justifyContent: 'center',
        marginTop: theme.spacing(3),
        flexWrap: 'wrap',
    },
    list: {
        paddingLeft: '2rem',
    },
});

class AdminShipmentInstructionsPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            estimativaNumero: localStorage.getItem('estimativa_numero') || '---',
            clienteData: {
                cnpj: '---',
                nome: '---',
                empresa: '---',
                telefone: '---',
                email: '---',
            }
        };
    }

    componentDidMount() {
        this.loadClientData();
    }

    loadClientData = () => {
        const clienteData = {
            cnpj: '12.345.678/0001-90',
            nome: 'João Silva',
            empresa: 'Empresa Exemplo Ltda',
            telefone: '(11) 99999-9999',
            email: 'joao@empresa.com'
        };

        this.setState({ clienteData });
    }

    handlePrint = () => {
        window.print();
    }

    handleBackToHome = () => {
        console.log("Navegar para home");
    }

    render() {
        const { classes } = this.props;
        const { estimativaNumero, clienteData } = this.state;
        const { currentLanguage } = this.props
        const breadcrumbItems = [
            { label: currentLanguage.bepiService.shared.shared_breadcrumb_home, path: '/bepi/admin' },
            { label: currentLanguage.bepiService.admin.admin_breadcrumb_shipment },
        ];


        return (
            <BreadcrumbLayout
                title={currentLanguage.bepiService.admin.admin_breadcrumb_shipment}
                breadcrumbItems={breadcrumbItems}
                currentLanguage={currentLanguage}
                showBackButton
            >
                <Container className={classes.container}>
                    <Paper className={classes.printArea}>
                        <Typography className={classes.title}>
                            {currentLanguage.bepiService.admin.admin_shipment_title_main}
                        </Typography>

                        <Typography className={classes.bodyText}>
                            {currentLanguage.bepiService.admin.admin_shipment_msg_important_print}
                        </Typography>

                        <Box className={classes.section}>
                            <Typography className={classes.subTitle}>
                                {currentLanguage.bepiService.admin.admin_shipment_title_order_data}
                            </Typography>
                            <Box className={classes.highlightText}>
                                {currentLanguage.bepiService.admin.admin_shipment_label_estimate_num} {estimativaNumero}
                            </Box>
                            <Box className={classes.highlightText}>
                                {currentLanguage.bepiService.admin.admin_shipment_label_cnpj} {clienteData.cnpj}
                            </Box>
                        </Box>

                        <Box className={classes.section}>
                            <Typography className={classes.subTitle}>
                                {currentLanguage.bepiService.admin.admin_shipment_title_sender}
                            </Typography>
                            <Typography className={classes.bodyText}><strong className={classes.inlineBlockText}>{currentLanguage.bepiService.admin.admin_shipment_label_client}</strong> {clienteData.nome}</Typography>
                            <Typography className={classes.bodyText}><strong className={classes.inlineBlockText}>{currentLanguage.bepiService.admin.admin_shipment_label_company}</strong> {clienteData.empresa}</Typography>
                            <Typography className={classes.bodyText}><strong className={classes.inlineBlockText}>{currentLanguage.bepiService.admin.admin_shipment_label_phone}</strong> {clienteData.telefone}</Typography>
                            <Typography className={classes.bodyText}><strong className={classes.inlineBlockText}>{currentLanguage.bepiService.admin.admin_shipment_label_email}</strong> {clienteData.email}</Typography>
                        </Box>

                        <Box className={classes.section}>
                            <Typography className={classes.subTitle}>
                                {currentLanguage.bepiService.admin.admin_shipment_title_shipping_address}
                            </Typography>
                            <Typography className={classes.bodyText}><strong>{currentLanguage.bepiService.admin.admin_shipment_address_company_name}</strong></Typography>
                            <Typography className={classes.bodyText}>{currentLanguage.bepiService.admin.admin_shipment_address_street}</Typography>
                            <Typography className={classes.bodyText}>{currentLanguage.bepiService.admin.admin_shipment_address_city_zip}</Typography>
                        </Box>

                        <Box className={classes.section}>
                            <Typography className={classes.subTitle}>
                                {currentLanguage.bepiService.admin.admin_shipment_title_general_instructions}
                            </Typography>
                            <Box component="ul" className={classes.list}>
                                <Typography component="li">{currentLanguage.bepiService.admin.admin_shipment_instruction_1}</Typography>
                                <Typography component="li">{currentLanguage.bepiService.admin.admin_shipment_instruction_2}</Typography>
                                <Typography component="li">{currentLanguage.bepiService.admin.admin_shipment_instruction_3}</Typography>
                                <Typography component="li">{currentLanguage.bepiService.admin.admin_shipment_instruction_4}</Typography>
                                <Typography component="li">{currentLanguage.bepiService.admin.admin_shipment_instruction_5}</Typography>
                                <Typography component="li">{currentLanguage.bepiService.admin.admin_shipment_instruction_6}</Typography>
                            </Box>
                        </Box>

                        <Box className={classes.observationSection}>
                            {currentLanguage.bepiService.admin.admin_shipment_msg_warning_nf}
                        </Box>

                        <Box className={classes.warningSection}>
                            <Typography className={classes.warningText}>{currentLanguage.bepiService.admin.admin_shipment_msg_warning_missing_data}</Typography>
                        </Box>

                        <Box className={classes.signatureSection}>
                            <Typography className={classes.signatureText}><strong>{currentLanguage.bepiService.admin.admin_shipment_footer_technical_service}</strong></Typography>
                            <Typography className={classes.signatureText}>{currentLanguage.bepiService.admin.admin_shipment_footer_whatsapp}</Typography>
                        </Box>

                        <Box className={classes.buttonGroup} style={{ display: 'none' }}>
                            <CustomButton
                                variant="blueOutlined"
                                startIcon={<HomeIcon />}
                                onClick={this.handleBackToHome}
                            >
                                {currentLanguage.bepiService.admin.admin_shipment_btn_back_home}
                            </CustomButton>
                            <CustomButton
                                variant="blueFilled"
                                startIcon={<PrintIcon />}
                                onClick={this.handlePrint}
                            >
                                {currentLanguage.bepiService.admin.admin_shipment_btn_print}
                            </CustomButton>
                        </Box>
                    </Paper>

                    <Box className={classes.buttonGroup}>
                        <CustomButton
                            variant="blueOutlined"
                            icon={<HomeIcon style={{ fontSize: '1rem', marginRight: '0.25rem' }} />}
                            onClick={this.handleBackToHome}
                        >
                            {currentLanguage.bepiService.admin.admin_shipment_btn_back_home}
                        </CustomButton>
                        <CustomButton
                            variant="grayOutlined"
                            icon={<PrintIcon style={{ fontSize: '1rem', marginRight: '0.25rem' }} />}
                            onClick={this.handlePrint}
                        >
                            {currentLanguage.bepiService.admin.admin_shipment_btn_print}
                        </CustomButton>
                    </Box>
                </Container>
            </BreadcrumbLayout>
        );
    }
}

export default withStyles(styles)(AdminShipmentInstructionsPage);
